import React from 'react';
import { Card } from 'react-bootstrap';
import './VisitorManagement.css';

const VisitorStatCard = ({ title, value, icon: Icon, color }) => {
    return (
        <div className="db1-stat-card p-3" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div className="db1-stat-icon" style={{ backgroundColor: `${color}18`, color: color }}>
                <Icon size={26} />
            </div>
            <div>
                <p style={{ margin: 0, fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#7f8c9b' }}>{title}</p>
                <h3 style={{ margin: 0, fontWeight: 700, color: '#2c3e50', fontSize: '1.75rem', lineHeight: 1.2 }}>{value}</h3>
            </div>
        </div>
    );
};

export default VisitorStatCard;
